interface IGetAmount {
  period: 'daily' | 'monthly';
  isModifiedByUser: boolean;
  value: number;
}

const getAmount = (props: IGetAmount) => {
  const { value, period, isModifiedByUser } = props;

  const numOfDays = period === 'monthly' ? 30 : 1;
  const amount = !isModifiedByUser ? Number(0) : value * numOfDays;

  const formattedAmount = amount.toFixed(2);

  return `${formattedAmount}$`;
};

export default getAmount;
